import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateProposalClientModel,
  DeleteProposalClientModel,
  SearchProposalClientModel,
} from '../../../models/proposal-client.model'

@Injectable({
  providedIn: 'root',
})
export class ScheduleVehicleService {
  private baseUrl = environment.baseUrl
  private resource: string = 'AgendaVeiculo'

  constructor(private httpClient: HttpClient) { }

  public createAgendaVeiculo(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAgendaVeiculo(
    model: any,
    // model: EditProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteAgendaVeiculo(
    id: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`,
      id,
    )
  }



  public listPagedAgendaVeiculo(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,

    )
  }

  public listPagedFreeVehicles(
    page: number,
    rows: number = 15,
    id: any
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/veiculos-livres?pageNumber=${page}&pageSize=${rows}`,
      id
    )
  }

  public listPagedAgendaVeiculoByOs(
    page: number,
    rows: number = 15,
    id: any
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/veiculos-ordem-servico?pageNumber=${page}&pageSize=${rows}`,
      id
    )
  }

  public searchAgendaVeiculo(
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listAgendaVeiculo(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getAgendaVeiculobyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedAgendaVeiculo(
    page: number,
    rows: number = 15,
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

}
